import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

import "./charts/dashboard.css";
import "./FinanceDashboard/FinanceDashboard.css";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  getMinDateByTime,
  tableLoading,
  checkPermission,
  customStyle,
  BranchMultiValue,
  branchSelectStyles,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Tab, Tabs, Nav } from "react-bootstrap";
import { FiGrid, FiUsers } from "react-icons/fi";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

//pages & includes
import ReportSidebar from "./ReportSidebar";
//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";

// graphs
import { CardsWidget, ColumnsWidget, DonutWidget, TableListDynamic } from "./charts";
import ListWidget from "./charts/ListWidget";
import VerticalBarWidget from "./charts/VerticalBarWidget";
import BarWidget from "./charts/BarWidget";
import LineWidget from "./charts/LineWidget";
import RadialWidget from "./charts/RadialWidget";
import HourlyBar from "./charts/HourlyBar";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import CustomVerticalBar from "./charts/CustomVerticalBar";
import WaiterPerformanceWidget from "./WaiterPerformanceWidget.js";
import ModernMultiChartWidget from "./charts/ModernMultiChartWidget";
import { chartThemeColors as PALETTE } from "./charts";

const DeicdeVisual = ({ type, data, heading, previous = null, date = null, onItemWiseDownload = null }) => {
  switch (type) {
    case "cards_widget":
      return <CardsWidget data={data} heading={heading} previous={previous}/>;
    case "bars_widget":
      return <ColumnsWidget data={data} heading={heading} size="col-8"/>;
    case "column_widget":
      return <VerticalBarWidget data={data} heading={heading} size="col-3"/>;
    case "custom_column_widget":
      return <CustomVerticalBar data={data} heading={heading} size="col-4"/>;
    case "hbars_widget" : 
      return <BarWidget data={data} heading={heading} size="col-3"/>;
    case "pie_widget" : 
     return  <RadialWidget  data={data} heading={heading}/>;
    case "hours_bar" : 
     return  <HourlyBar  data={data} heading={heading}/>;
    case "line_widget" : 
      return  <LineWidget data={data} heading={heading} size="col-8"/>;
    // Combined donut_widget and dounut_widgets cases below
    case "list_view" : {
      const isItemWise = heading?.toLowerCase() === "item wise sales" || heading?.toLowerCase().includes("item wise");
      return(
        heading?.toLowerCase() === "branch wise sales" ?
          <ListWidget data={data} heading={heading} size="col-12"/>
        :
        <div className="d-flex p-0 w-50">
          <ListWidget 
            data={data} 
            heading={heading} 
            size="col-12"
            onDownload={isItemWise ? onItemWiseDownload : null}
          />
        </div>
      );
    }
    case "online_widget":
      return <TableListDynamic data={data} heading={heading} size="col-12" date={date}/>;
    case "multi_chart_widget":
      return <ModernMultiChartWidget data={data} heading={heading} size="col-6"/>;
    case "donut_widget":
      if (heading === "Order Type Wise Sales" && data && typeof (data) === "object") {
        return (
          <>
            {Object.keys(data).map((key, index) => (
              <ModernMultiChartWidget
                heading={key.charAt(0).toUpperCase() + key.slice(1)}
                badgeColor={PALETTE[index % PALETTE.length]}
                badgeType={key}
                size="col-6"
                data={data[key]}
              />
            ))}
          </>
        );
      }
      return <DonutWidget data={data} heading={heading} size="col-3"/>;
    default:
      return null;
  }
};

var authUser = "";
var authBranch = "";

const getAxiosReq = (details, params) => {
  const url = `${BASE_URL}/${details.prefix}/${details.endpoint}`;
  if (details.method === "POST") {
    const formData = {};
    if (details.params.includes("range")) {
      formData.range = (params?.from && params?.to) ? 24 : 12;
    }
    for (const key in params) {
      if (details.params.includes(key)) {
        formData[key] = params[key];
      }
    }
    if((authUser?.details?.user_type === "staff" || authUser?.details?.user_type === "manager")&& !formData.branch_id){
      formData.branch_id = authBranch?.id
    }
    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => res.data)
      .catch((err) => err);
  } else if (details.method === "GET")
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => res.data)
      .catch((err) => err);
};

const Reports = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);

  let { branchForSearch } = useContext(RestaurantContext);
  let { authUserInfo } = useContext(UserContext);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);

  const [cardData, setCardData] = useState(null);
  const [allApis, setAllApis] = useState(null);
  
  const [key, setKey] = useState("dashboard");
  const [filterCount, setFilterCount] = useState(0);

  const [itemWiseExportData, setItemWiseExportData] = useState(null);
  const itemWiseExcelRef = useRef();

  const siteName = getSystemSettings(generalSettings, "siteName");
  const date = {
    startDate: startDate,
    endDate: endDate,
  }

  // auth
  useEffect(() => {
    // TODO: remove this
    // return;
    if (
      authUserInfo?.details?.user_type === "staff" || authUserInfo?.details?.user_type === "call_center" || 
      authUserInfo?.details?.user_type === "manager" || authUserInfo?.details?.user_type === "multi_manager"
      // !checkPermission(authUserInfo.permissions, "Report Dashboard")
    ) {
      if(checkPermission(authUserInfo.permissions, "Dashboard"))
        history.push("/dashboard/reports");
      else if(checkPermission(authUserInfo.permissions, "Table View"))
        history.push("/dashboard/table-view");
      /*else if (checkPermission(authUserInfo.permissions, "Daily Report"))
        history.push("/dashboard/daily-reports");
      else if (checkPermission(authUserInfo.permissions, "Monthly Report"))
        history.push("/dashboard/monthtly-reports");*/
      else if (checkPermission(authUserInfo.permissions, "Work Period Report"))
        history.push("/dashboard/work-period-reports");
      else if (checkPermission(authUserInfo.permissions, "Sales Report"))
        history.push("/dashboard/sales-reports");
      else if (checkPermission(authUserInfo.permissions, "Sales Summary Report"))
        history.push("/dashboard/sales-summary-reports");
      else if (checkPermission(authUserInfo.permissions, "Source Wise Report"))
        history.push("/dashboard/source-wise-reports");
      else if (checkPermission(authUserInfo.permissions, "Customer Order History"))
        history.push("/dashboard/customer-order-history-reports");
      else if (checkPermission(authUserInfo.permissions, "Food Panda Report"))
        history.push("/dashboard/food-panda-reports");
      else if (checkPermission(authUserInfo.permissions, "Meezan Report"))
        history.push("/dashboard/meezan-reports");
      else if (checkPermission(authUserInfo.permissions, "Cancel Order Report"))
        history.push("/dashboard/cancel-order-reports");
      else if (checkPermission(authUserInfo.permissions, "Cancel Item Report"))
        history.push("/dashboard/cancel-made-unmade-reports");
      else if (checkPermission(authUserInfo.permissions, "Hourly Sales Report"))
        history.push("/dashboard/hourly-sales-reports");
      else if (checkPermission(authUserInfo.permissions, "Daily Cash Sales Report"))
        history.push("/dashboard/daily-cash-sales-reports");
      else if (checkPermission(authUserInfo.permissions, "Stock Consumption Report"))
        history.push("/dashboard/stock-consumption-reports");
      else if(checkPermission(authUserInfo.permissions, "Sales Tender Report"))
        history.push("/dashboard/sales-tender-reports");
      else if(checkPermission(authUserInfo.permissions, "SRB Report"))
        history.push("/dashboard/srb-report");
      else if(checkPermission(authUserInfo.permissions, "Order Tracking Report"))
        history.push("/dashboard/order-tracking-reports");
      else if(checkPermission(authUserInfo.permissions, "Gross Sales Report"))
        history.push("/dashboard/gross-sales-reports");
      else if(checkPermission(authUserInfo.permissions, "Tax Report"))
        history.push("/dashboard/tax-sales-reports");
      else if(checkPermission(authUserInfo.permissions, "Foc Report"))
        history.push("/dashboard/foc-reports");
      else if(checkPermission(authUserInfo.permissions, "Deals Report"))
        history.push("/dashboard/deal-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Report"))
        history.push("/dashboard/finished-goods-ledger-reports");
      else if(checkPermission(authUserInfo.permissions, "Inventory Report"))
        history.push("/dashboard/inventory-reports");
      else if(checkPermission(authUserInfo.permissions, "Discount Wise Report"))
        history.push("/dashboard/discount-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Movement Report"))
        history.push("/dashboard/fg-movement-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Transfer Report"))
        history.push("/dashboard/fg-transfer-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Hamper Report"))
        history.push("/dashboard/gift-hamper-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Packing Report"))
        history.push("/dashboard/fg-packing-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Discard Report"))
        history.push("/dashboard/fg-discard-reports");
      else if(checkPermission(authUserInfo.permissions, "Finished Goods Adjustment Report"))
        history.push("/dashboard/fg-adjustment-reports");
      else if(checkPermission(authUserInfo.permissions, "Stock Adjustment Report"))
        history.push("/dashboard/stock-adjustment-reports");
      else if(checkPermission(authUserInfo.permissions, "Purchase Order Report"))
        history.push("/dashboard/purchase-order-reports");
      else if(checkPermission(authUserInfo.permissions, "Purchase Request Report"))
        history.push("/dashboard/purchase-request-reports");
      else if(checkPermission(authUserInfo.permissions, "Goods Recieved Note Report"))
        history.push("/dashboard/grn-reports");
      else if(checkPermission(authUserInfo.permissions, "Supplier Ledger"))
        history.push("/dashboard/supplier-ledger-reports");
      else if(checkPermission(authUserInfo.permissions, "Recipe Report"))
        history.push("/dashboard/recipe-reports");
      else if(checkPermission(authUserInfo.permissions, "Purchase Invoice Report"))
        history.push("/dashboard/purchase-invoice-reports");
      else if(checkPermission(authUserInfo.permissions, "Stock Transfer Report"))
        history.push("/dashboard/stock-transfer-reports"); 
      else if(checkPermission(authUserInfo.permissions, "Production Report"))
        history.push("/dashboard/production-reports");
      else if(checkPermission(authUserInfo.permissions, "Stock Ledger Report"))
        history.push("/dashboard/stock-ledger-reports");
      else if(checkPermission(authUserInfo.permissions, "Raw Movement Report"))
        history.push("/dashboard/raw-movement-reports");
      else if(checkPermission(authUserInfo.permissions, "Stock Variance Report"))
        history.push("/dashboard/stock-variance-reports");
      else if(checkPermission(authUserInfo.permissions, "Stock Transfer Report"))
        history.push("/dashboard/stock-transfer-reports");
      else if(checkPermission(authUserInfo.permissions, "Ingredient Item Report"))
        history.push("/dashboard/ingredient-item-reports");
      else if(checkPermission(authUserInfo.permissions, "Expense Report"))
        history.push("/dashboard/expense-reports");
      else if(checkPermission(authUserInfo.permissions, "Rider Report"))
        history.push("/dashboard/rider-reports");
      else if(checkPermission(authUserInfo.permissions, "Waiter Report"))
        history.push("/dashboard/waiter-reports");
      else if(checkPermission(authUserInfo.permissions, "Income Statement Report"))
        history.push("/dashboard/income-statement-reports");
      else if(checkPermission(authUserInfo.permissions, "Item Food Cost Report"))
        history.push("/dashboard/food-items-reports");  
      else if(checkPermission(authUserInfo.permissions, "Callcenter Report"))
        history.push("/dashboard/call-center-reports");
      else if(checkPermission(authUserInfo.permissions, "Menu Mix Report"))
        history.push("/dashboard/menu-mix-reports");
      else if(checkPermission(authUserInfo.permissions, "Customer Order History Report"))
        history.push("/dashboard/customer-order-reports");
      else if(checkPermission(authUserInfo.permissions, "Food Item Report"))
        history.push("/dashboard/all-item-report");
      else if(checkPermission(authUserInfo.permissions, "Customer Report"))
        history.push("/dashboard/customer-report");
      else if(checkPermission(authUserInfo.permissions, "Month Stock Report"))
        history.push("/dashboard/month-stock-reports");
      else if(checkPermission(authUserInfo.permissions, "Sale Invoice Report"))
        history.push("/dashboard/sale-invoice-reports");
      else if(checkPermission(authUserInfo.permissions, "FG Sale Invoice Report"))
        history.push("/dashboard/fg-sale-invoice-reports");
      else if(checkPermission(authUserInfo.permissions, "Sale Return Report"))
        history.push("/dashboard/sale-return-reports");
      else if(checkPermission(authUserInfo.permissions, "Opening Report"))
        history.push("/dashboard/opening-reports");
      else if(checkPermission(authUserInfo.permissions, "Ingredient Consumption Report"))
        history.push("/dashboard/ingredient-consumption-reports");
      else if(checkPermission(authUserInfo.permissions, "Ingredient Conversion Report"))
        history.push("/dashboard/ingredient-conversion-reports");
      else if(checkPermission(authUserInfo.permissions, "Ingredient Cost Report"))
        history.push("/dashboard/food-cost-reports");
      else if(checkPermission(authUserInfo.permissions, "Po To Pi Report"))
        history.push("/dashboard/po-to-pi-report");   
      else if(checkPermission(authUserInfo.permissions, "RCR Audit Report"))
        history.push("/dashboard/rcr-reports");   
      else {
        history.push("/dashboard");
        toast.error("You cannot access any reports.", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }

    if (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") {
      let branchFilter = branchForSearch.find((branch) => branch.id === authUserInfo.details.branch_id)
      setBranch(branchFilter);
      authBranch = branchFilter && branchFilter
      authUser = authUserInfo;
    }
  }, [authUserInfo]);

  // data fetching
  useEffect(() => {
    //setLoading(true);
    getReport(() => {
      setLoading(false);
    });
  }, []);

  //get reports
  const getReport = (cb) => {
    const url = BASE_URL + "/widgets/get-api-details";
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data.status == 200) {
          const allApisTemp = res.data.details;
          setAllApis(allApisTemp);
          getAllApis(allApisTemp);
        }
      })
      .catch((error) => {})
      .finally(cb);
  };
  const getAllApis = async (allApisTemp, formData = {}) => {
    setDataPaginating(true);
    const allRes = await Promise.all(
      allApisTemp.map((api) => getAxiosReq(api, formData))
    );
    setDataPaginating(false);
    setCardData(
      allRes.map((res, index) => {
        return {
          type: allApisTemp[index].web_type,
          heading: allApisTemp[index].heading,
          date: date,
          data: res.status == 200 ? res.details : { error: res.message },
          ...(allApisTemp[index].web_type.match(/cards(.*)widget/i) && {previous:res.status == 200 ? res.previous : { error: res.message }})
        };
      })
    );
  };

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleApplyFilter = () => {
    const formData = {};
    const branchData = branch?.length ? branch.map((branch) => branch.id) : "";
    if (branchData && branchData?.length) formData.branch_id = branchData;
    if (startDate) formData.from = moment(startDate).format("YYYY-MM-DD");
    if (endDate) formData.to = moment(endDate).format("YYYY-MM-DD");
    
    if (key === "dashboard") {
      getAllApis(allApis, formData);
    } else {
      setFilterCount((prev) => prev + 1);
    }
  };

  // Dedicated download handler for Item Wise Sales: fetches from /settings/branchwise-itemsales with available filters and downloads Excel grouped by branch
  const handleItemWiseExcelDownload = async () => {
    try {
      const branch_id = branch?.length ? branch.map((b) => b.id) : (branch?.id || (["staff", "manager"].includes(authUserInfo?.details?.user_type) ? (authBranch?.id || authUserInfo?.details?.branch_id) : ""));
      const from = startDate ? moment(startDate).format("YYYY-MM-DD") : undefined;
      const to = endDate ? moment(endDate).format("YYYY-MM-DD") : undefined;

      const res = await axios.post(
        `${BASE_URL}/settings/branchwise-itemsales`,
        { branch_id: branch_id || undefined, from, fromDate: from, to, toDate: to },
        { headers: { Authorization: `Bearer ${getCookie()}` } }
      );

      if (res?.data?.status === 200 || res?.data?.status === "200") {
        setItemWiseExportData(res.data.data || {});
        setTimeout(() => itemWiseExcelRef.current?.handleDownload(), 150);
      } else {
        toast.error(res?.data?.message || _t(t("Failed to fetch item wise data")), {
          position: "bottom-center",
          closeButton: false,
          autoClose: 5000,
          className: "text-center toast-notification",
        });
      }
    } catch (error) {
      console.error("Item wise excel download error:", error);
      toast.error(_t(t("An error occurred while downloading item wise report")), {
        position: "bottom-center",
        closeButton: false,
        autoClose: 5000,
        className: "text-center toast-notification",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Dashboard"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form reports-dashboard">
                        <CustomSpinLoader loading={loading || dataPaginating}/>

                        {/* Hidden Excel Component and Table for Item Wise Sales Export */}
                        <ReactHTMLTableToExcel
                          id="item-wise-sales-xls-btn"
                          className="d-none"
                          table="item-wise-sales-excel-table"
                          filename={`Item_Wise_Sales_${moment().format("YYYY-MM-DD")}`}
                          sheet="Item Wise Sales"
                          buttonText="Export XLS"
                          ref={itemWiseExcelRef}
                        />
                        <div className="d-none">
                          <table id="item-wise-sales-excel-table" className="table">
                            <thead>
                              <tr>
                                <th colSpan="4" style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>
                                  {siteName ? `${siteName} - ` : ""}Item Wise Sales Report
                                </th>
                              </tr>
                              {(startDate || endDate) && (
                                <tr>
                                  <th colSpan="4" style={{ textAlign: "center" }}>
                                    {startDate ? `FROM: ${moment(startDate).format("YYYY-MM-DD")}` : ""}
                                    {endDate ? ` TO: ${moment(endDate).format("YYYY-MM-DD")}` : ""}
                                  </th>
                                </tr>
                              )}
                              <tr style={{ backgroundColor: "#e9ecef", fontWeight: "bold" }}>
                                <th>S/L</th>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Sales</th>
                              </tr>
                            </thead>
                            <tbody>
                              {itemWiseExportData &&
                                Object.entries(itemWiseExportData).map(([branchName, items = []], bIdx) => {
                                  let totalQty = 0, totalSales = 0;
                                  return (
                                    <React.Fragment key={bIdx}>
                                      <tr style={{ backgroundColor: "#d0e1fd", fontWeight: "bold" }}>
                                        <th colSpan="4" style={{ textAlign: "left", padding: "8px" }}>Branch: {branchName}</th>
                                      </tr>
                                      {items.map((it, i) => {
                                        totalQty += Number(it.quantity) || 0;
                                        totalSales += Number(it.sales) || 0;
                                        return (
                                          <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{it.food_name || it.name || "-"}</td>
                                            <td>{it.quantity}</td>
                                            <td>{it.sales}</td>
                                          </tr>
                                        );
                                      })}
                                      <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
                                        <td colSpan="2" style={{ textAlign: "right" }}>Total for {branchName}:</td>
                                        <td>{totalQty}</td>
                                        <td>{totalSales.toFixed(2)}</td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>

                        {/* Modernized Single Row Bar: Tabs on Left, Filters on Right */}
                        <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                          <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-2 border-bottom pb-2 pt-2 mb-3">
                             {/* Left: Modernized Tabs Navigation */}
                            <div className="d-flex align-items-center">
                              <Nav variant="pills" className="dashboard-modern-tabs">
                                <Nav.Item>
                                  <Nav.Link eventKey="dashboard">
                                    <FiGrid className="tab-icon" />
                                    <span>{_t(t("Dashboard"))}</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                  <Nav.Link eventKey="waiter">
                                    <FiUsers className="tab-icon" />
                                    <span>{_t(t("Waiter/Cashier Performance"))}</span>
                                  </Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </div>

                            {/* Right: Date, Branch & Small View Dashboard Button */}
                            <div className="d-flex align-items-center gap-2 flex-wrap justify-content-start justify-content-lg-end">
                              <div style={{ width: "140px" }}>
                                <DatePicker
                                  selected={startDate}
                                  onChange={(date) => setStartDate(date)}
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control form-control-sm py-1 rounded finance-date-picker"
                                  placeholderText={_t(t("From date"))}
                                  shouldCloseOnSelect={true}
                                />
                              </div>

                              <div style={{ width: "140px" }}>
                                <DatePicker
                                  selected={endDate}
                                  onChange={(date) => setEndDate(date)}
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control form-control-sm py-1 rounded finance-date-picker"
                                  placeholderText={_t(t("To date"))}
                                  shouldCloseOnSelect={true}
                                />
                              </div>

                              <div style={{ minWidth: "160px", maxWidth: "220px" }} className="flex-grow-1 flex-lg-grow-0">
                                <Select
                                  options={branchForSearch ? branchForSearch : []}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={branch}
                                  isClearable
                                  classNamePrefix="select"
                                  className="sm-text"
                                  onChange={handleBranch}
                                  isMulti
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  components={{
                                    MultiValue: BranchMultiValue,
                                    MultiValueRemove: () => null,
                                  }}
                                  styles={branchSelectStyles}
                                  maxMenuHeight="180px"
                                  placeholder={_t(t("Select a branch")) + ".."}
                                  isDisabled={authUserInfo ? (authUserInfo?.details?.user_type === "staff" || authUserInfo?.details?.user_type === "manager") : false}
                                />
                              </div>

                              <button
                                className="btn btn-primary btn-sm text-uppercase px-3 py-1 rounded shadow-sm font-weight-semibold"
                                style={{ height: "31px", fontSize: "12px", whiteSpace: "nowrap" }}
                                onClick={handleApplyFilter}
                              >
                                {_t(t("View Dashboard"))}
                              </button>
                            </div>
                          </div>

                          {/* Tab Content Panes */}
                          <Tab.Content>
                            <Tab.Pane eventKey="dashboard">
                              <div className="row gx-2 mt-2 mb-3">
                                {cardData
                                  ? cardData.map((card, index) => (
                                      <DeicdeVisual
                                        key={index}
                                        type={card.type}
                                        data={card.data}
                                        heading={card.heading}
                                        previous={card?.previous && card?.previous}
                                        date={card?.date}
                                        onItemWiseDownload={handleItemWiseExcelDownload}
                                      />
                                    ))
                                  : ""}
                              </div>
                            </Tab.Pane>

                            <Tab.Pane eventKey="waiter">
                              <WaiterPerformanceWidget
                                activeKey={key}
                                startDate={startDate}
                                endDate={endDate}
                                branch={branch}
                                date={date}
                                filterTrigger={filterCount}
                              />
                            </Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default Reports;
